// extracted by mini-css-extract-plugin
module.exports = {"typeLabel":"Type_typeLabel__1Hyaj"};